export enum EventStatusAll {
    Apen = 'Åpen',
    Forespurt = 'Forespurt',
    Rapportert = 'Rapportert',
    FeilrettingPagar = 'Feilretting pågår',
    Evaluering = 'Evaluering',
    Utredning = 'Utredning',
    VenterSvar = 'Venter svar',
    Godkjent = "Godkjent",
    Oppfolging = 'Oppfølging',
    ProvisoriskLost = 'Provisorisk løst',
    Lukket = 'Lukket',
}


export enum EventStatus {
    Apen = 'Åpen',
    Lukket = 'Lukket',
};

export enum IncidentStatus {
    Rapportert = 'Rapportert',
    Utredning = 'Utredning',
    FeilrettingPagar = 'Feilretting pågår',
    Evaluering = 'Evaluering',
    ProvisoriskLost = 'Provisorisk løst',
    Lukket = 'Lukket',
};

export enum PlannedWorkStatus {
    Forespurt = 'Forespurt',
    Utredning = 'Utredning',
    VenterSvar = 'Venter svar',
    Godkjent = "Godkjent",
    Oppfolging = 'Oppfølging',
    Lukket = 'Lukket',
};

export enum EventType {
    Generell = 'Generell',
    Planlagt = 'Planlagt',
    Fellesfeil = 'Fellesfeil'
};

export enum EventTypeShort {
    Generell = 'GE',
    Planlagt = 'PA',
    Fellesfeil = 'FF'
};

export enum PlannedWorkCriticality {
    Low = 'Lav',
    Medium = 'Medium',
    High = 'Høy'
};

export enum PlannedWorkCategory {
    Standard = 'Standard',
    NormalLow = 'Normalt - Lav',
    NormalHigh = 'Normalt - Høyt',
    Critical = 'Kritisk'
};

export enum IncidentCriticality {
    A = 'A',
    B = 'B',
    C = 'C'
};

export enum IncidentCategory {
    Low = 'Lav',
    Medium = 'Medium',
    High = 'Høy',
    Critical = 'Kritisk'
};

export enum CategoryAll {
    Low = 'Lav',
    Medium = 'Medium',
    Standard = 'Standard',
    NormalLow = 'Normalt - Lav',
    NormalHigh = 'Normalt - Høyt',
    High = 'Høy',
    Critical = 'Kritisk',
}

export enum CriticalityAll {
    Low = 'Lav',
    Medium = 'Medium',
    High = 'Høy',
    Critical = 'Kritisk',
    A = 'A',
    B = 'B',
    C = 'C'
}
